/* Matcha Sunday — Coffee-Crash landing interactions.
   1) Energy-curve: auto-toggles Coffee<->Matcha on a timer while in view (scroll-triggered);
      manual button clicks still work and stop the auto-cycle.
   2) Quantity +/- on the custom buy box (dispatches input so ms-supply.js reprices). */
(function () {
  var CAPS = {
    coffee: 'Coffee: a big spike, then the 2pm crash.',
    matcha: 'Matcha Sunday: steady, level energy for hours.'
  };
  function setMode(wrap, mode) {
    wrap.setAttribute('data-curve-mode', mode);
    wrap.querySelectorAll('.mslp__curve-btn').forEach(function (b) {
      var on = b.getAttribute('data-curve') === mode;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var cap = wrap.querySelector('[data-curve-cap]');
    if (cap) cap.textContent = CAPS[mode] || '';
  }
  function initCurve() {
    var wrap = document.getElementById('mslp-curve');
    if (!wrap || wrap.__ms) return; wrap.__ms = true;
    var timer = null;
    function start() {
      if (timer) return;
      timer = setInterval(function () {
        var cur = wrap.getAttribute('data-curve-mode');
        setMode(wrap, cur === 'coffee' ? 'matcha' : 'coffee');
      }, 3000);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    wrap.querySelectorAll('.mslp__curve-btn').forEach(function (btn) {
      btn.addEventListener('click', function () { stop(); setMode(wrap, btn.getAttribute('data-curve')); });
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) start(); else stop(); });
      }, { threshold: 0.4 }).observe(wrap);
    } else { start(); }
  }
  function initQty() {
    document.querySelectorAll('.mslp__qty').forEach(function (q) {
      if (q.__ms) return; q.__ms = true;
      var input = q.querySelector('input[name="quantity"]');
      if (!input) return;
      q.querySelectorAll('.mslp__qtybtn').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(input.value, 10) || 1;
          v = b.getAttribute('data-q') === '+' ? v + 1 : Math.max(1, v - 1);
          input.value = v;
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }
  // Sticky add-to-cart is its OWN native /cart/add form, so it always works (no JS needed
  // for the add). This just mirrors the live buy-box selection (variant + plan + qty) into it.
  function initStickySync() {
    var sticky = document.getElementById('rtg-sticky-form');
    if (!sticky || sticky.__ms) return; sticky.__ms = true;
    var hero = document.getElementById(sticky.getAttribute('data-hero') || 'ms-lp-rtg-form');
    if (!hero) return;
    function field(form, n) { return form.querySelector('[name="' + n + '"]'); }
    function sync() {
      var hid = field(hero, 'id'), hpl = field(hero, 'selling_plan'), hqt = field(hero, 'quantity');
      var sid = sticky.querySelector('[data-sticky-id]'), spl = sticky.querySelector('[data-sticky-plan]'), sqt = sticky.querySelector('[data-sticky-qty]');
      if (hid && sid) sid.value = hid.value;
      if (sqt) sqt.value = (hqt && hqt.value) ? hqt.value : '1';
      if (spl) { var v = hpl ? hpl.value : ''; spl.value = v; spl.disabled = !v; }
    }
    sync();
    hero.addEventListener('change', sync);
    hero.addEventListener('input', sync);
    // Guarantee correctness: re-read the live selection at the moment of submit, before the
    // native POST serializes the form (the picker updates hidden fields without firing events).
    sticky.addEventListener('submit', sync);
    setTimeout(sync, 600); setTimeout(sync, 1600);
  }
  function init() { initCurve(); initQty(); initStickySync(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
